import { Navigate, useNavigate } from 'react-router';
import { ChooseMFA } from '#components/patterns/mfa/choose/ChooseMFA.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { page, Titled } from '#util/title.ts';
import { isWebAuthnSupported } from '#util/webauthn-support.ts';
import { RegisterMFALayout } from './RegisterMFALayout.tsx';

/**
 * First-time MFA setup entry point. When the browser supports WebAuthn we let
 * the user pick between a passkey and an authenticator app; each choice
 * navigates to its own route so the enrollment steps have real URLs. When
 * WebAuthn isn't available there's nothing to choose, so we go straight to TOTP.
 */
export function RegisterMFA() {
  const navigate = useNavigate();
  const location = useAppLocation();

  if (!isWebAuthnSupported()) {
    return <Navigate to="totp" replace={true} state={location.state} />;
  }

  return (
    <Titled title={() => page('Register MFA')}>
      <RegisterMFALayout>
        <ChooseMFA
          onChoosePasskey={() => void navigate('passkey', { state: location.state })}
          onChooseTOTP={() => void navigate('totp', { state: location.state })}
        />
      </RegisterMFALayout>
    </Titled>
  );
}
